import { FinishTutorialTutor } from 'domain/usecases/user/finish-tutorial-tutor'
import { IUserRepositoryRepository } from 'repository/interfaces/user-repository'

export class RemoteFinishTutorialTutor implements FinishTutorialTutor {
  private readonly userRepository: IUserRepositoryRepository

  constructor(userRepository: IUserRepositoryRepository) {
    this.userRepository = userRepository
  }

  finishTutorialTutor(): Promise<FinishTutorialTutor.Model> {
    return this.userRepository.finishTutorialTutor()
  }
}

export type FinishTutorialTutorModel = FinishTutorialTutor.Model
